export const removePhoneMask = phone => {
	return phone.replace(/\D/g, '');
};
